import ChartBzdnAfbouw from "../../../../src/client/vvgn/json/bzdn-afbouw.json";
import ChartCollapse from "../../../../src/components/interactions/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  ChartBzdnAfbouw,
  ChartCollapse,
  React
};